import { Environments, UserFeatureFlags } from "./GlobalConstants";

export const DefaultFeatureFlags = {
    IS_DEBUG: false,
    IS_MOCK: false,
    IS_BETA: true,
    IS_REDESIGN: false,
    IS_UNIT_PROPERTY_REDESIGN: true,
    IS_GAME_CHANGERS: true,
    IS_BC_PRICING: false,
    IS_LMSV2: false,
    IS_RETAIL_PHASE_2: false,
    IS_LMSv2_DEBUG: false,
    IS_BROKER_FEE_ALLIANCE: false,
    IS_BORROWER_PORTAL: process.env.REACT_APP_ENV === Environments.PRODUCTION ? false : true,
    LOCAL_HOST: ""
};

const getLocalFeatureFlags = () => {
    const featureFlagObj = DefaultFeatureFlags;
    featureFlagObj.IS_DEBUG = true;
    featureFlagObj.IS_UNIT_PROPERTY_REDESIGN = true;
    featureFlagObj.IS_LMSV2 = true;
    featureFlagObj.IS_RETAIL_PHASE_2 = true;
    featureFlagObj.IS_LMSv2_DEBUG = true;
    featureFlagObj.LOCAL_HOST = "https://my-dev.builders-capital.com";
    // featureFlagObj.LOCAL_HOST = "https://portal.serviceyourloan-dev.com";
    // featureFlagObj.LOCAL_HOST = "https://builderscapital.serviceyourloan-dev.com";
    return featureFlagObj;
};

const getUserFeatureFlags = (user: any = undefined) => {
    const featureFlagObj = DefaultFeatureFlags;
    UserFeatureFlags.forEach((flag) => {
        if (user?.preferences?.featureFlags && user.preferences.featureFlags[flag.name]) {
            featureFlagObj[flag.name] = true;
        }
    });
    
    return featureFlagObj;
};

export const FeatureFlags = (process.env.REACT_APP_ENV === Environments.LOCAL) ? getLocalFeatureFlags() : DefaultFeatureFlags;
export const getFeatureFlags = (user = undefined) => getUserFeatureFlags(user);